export const generatePassword = (options) => {
    const { length = 10, includeSpecialCharacters = true, includeNumbers = true } = options || {};
    const upperCase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const lowerCase = "abcdefghijklmnopqrstuvwxyz";
    const numbers = "0123456789";
    const special = `!@#$%^&*()_-+=[]{}|';:",.<>?/~`;
    // Always include at least one upper and one lower case letter
    let result = [
        upperCase[Math.floor(Math.random() * upperCase.length)],
        lowerCase[Math.floor(Math.random() * lowerCase.length)]
    ];
    // Add required character types based on options
    if (includeNumbers) {
        result.push(numbers[Math.floor(Math.random() * numbers.length)]);
    }
    if (includeSpecialCharacters) {
        result.push(special[Math.floor(Math.random() * special.length)]);
    }
    // Calculate remaining length needed
    const remainingLength = length - result.length;
    // Create pool of allowed characters
    let charPool = upperCase + lowerCase;
    if (includeNumbers)
        charPool += numbers;
    if (includeSpecialCharacters)
        charPool += special;
    // Fill remaining length with random characters from pool
    for (let i = 0; i < remainingLength; i++) {
        result.push(charPool[Math.floor(Math.random() * charPool.length)]);
    }
    // Shuffle the array using Fisher-Yates algorithm
    for (let i = result.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [result[i], result[j]] = [result[j], result[i]];
    }
    return result.join("");
};
